export const updateIndustryRoute = '/employer/industry/';
export const getIndustriesRoute = '/positions/industries/';
